import React from 'react';
import Card, { CardContent } from '../../components/ui/Card';
import Button from '../../components/ui/Button';
import { DocumentDuplicateIcon } from '@heroicons/react/24/outline';

const AdminTaxesPage: React.FC = () => {
  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <div className="flex justify-between items-center mb-6">
        <h1 className="text-3xl font-bold text-gray-900">Tax Management</h1>
        <Button>Configure Taxes</Button>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-8">
        <Card><CardContent className="p-6"><div className="flex items-center justify-between"><div><p className="text-sm text-gray-600">Tax Forms Submitted</p><p className="text-2xl font-bold text-gray-900">456</p></div><DocumentDuplicateIcon className="w-8 h-8 text-blue-600" /></div></CardContent></Card>
        <Card><CardContent className="p-6"><div className="flex items-center justify-between"><div><p className="text-sm text-gray-600">Pending Review</p><p className="text-2xl font-bold text-gray-900">23</p></div><DocumentDuplicateIcon className="w-8 h-8 text-yellow-600" /></div></CardContent></Card>
        <Card><CardContent className="p-6"><div className="flex items-center justify-between"><div><p className="text-sm text-gray-600">Total Tax Collected</p><p className="text-2xl font-bold text-gray-900">$125,890</p></div><DocumentDuplicateIcon className="w-8 h-8 text-green-600" /></div></CardContent></Card>
      </div>

      <div className="space-y-6">
        <Card><CardContent className="p-6"><h2 className="text-xl font-semibold mb-4">Tax Settings</h2><p className="text-gray-600 mb-4">Configure tax rates and regions</p><Button>Manage Settings</Button></CardContent></Card>
        <Card><CardContent className="p-6"><h2 className="text-xl font-semibold mb-4">W-9 Forms</h2><p className="text-gray-600 mb-4">Review and manage W-9 tax forms</p><Button>View Forms</Button></CardContent></Card>
        <Card><CardContent className="p-6"><h2 className="text-xl font-semibold mb-4">Tax Reports</h2><p className="text-gray-600 mb-4">Generate tax reports for accounting</p><Button>Generate Report</Button></CardContent></Card>
      </div>
    </div>
  );
};

export default AdminTaxesPage;
